import { render } from "./SVGBracketCover.vue?vue&type=template&id=36dd7bf6"
const script = {}

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__